import {
    GroupedComboBoxRenderIcon,
    GroupedComboBoxRenderLabel,
    IGroupedComboBoxItem,
} from 'grouped-combobox-core';
import { findFontByKey } from '../../common/findFontByKey';
import { emptyIconProps } from '../../common/iconNames';
import { IMruEntry } from '../FontPicker.types.shared';

export function createMruItem(
    entry: IMruEntry,
    renderPreviewFont: GroupedComboBoxRenderLabel | undefined,
    onRenderIcon: GroupedComboBoxRenderIcon | undefined,
    allFonts?: IGroupedComboBoxItem[]
): IGroupedComboBoxItem {
    const { name, mruKey, variantType, displayName, themeStyle, fontFamilyKey } = entry;

    // If the MRU item has a parent in the All fonts section, give its L2 menu to the MRU item as well
    const parentItem =
        allFonts && !!fontFamilyKey ? findFontByKey(fontFamilyKey, allFonts) : undefined;

    return {
        text: name,
        displayText: displayName,
        itemKey: mruKey,
        sections: parentItem?.sections,
        data: entry,
        icon: emptyIconProps,
        onRenderIcon: onRenderIcon,
        secondaryText: themeStyle,
        onRenderLabel: variantType !== 'missing' ? renderPreviewFont : undefined,
        disableCheckSubItemForSelected: true,
    };
}
